import { IconButton } from '@mui/material';
import { useIntl } from 'react-intl';

import Icon from 'components/@icons/Icon';

import { transitionDirection } from './types';

interface Props {
  transitionDirection: transitionDirection;
  onClose: () => void;
}

const DialogActions = ({ transitionDirection, onClose }: Props) => {
  const intl = useIntl();

  if (transitionDirection === 'up') {
    return (
      <IconButton
        size="small"
        variant="filled"
        onClick={onClose}
        aria-label={intl.formatMessage({ id: 'navigation.close' })}
        sx={{
          position: 'absolute',
          right: { xs: 16, md: 24 },
          top: { xs: 16, md: 24 },
          zIndex: 1,
        }}
      >
        <Icon name="Close" fontSize={24} />
      </IconButton>
    );
  }

  return (
    <IconButton
      size="small"
      variant="filled"
      onClick={onClose}
      aria-label={intl.formatMessage({ id: 'navigation.back' })}
      sx={{
        position: 'absolute',
        left: { xs: 16, md: 24 },
        top: { xs: 16, md: 24 },
      }}
    >
      <Icon name="ArrowLeft" rotateInArabic fontSize={24} />
    </IconButton>
  );
};

export default DialogActions;
